<!--饼状图组件-->
<template>
  <div>
    保理分布图——饼图
    <div style="width: 40%;height: 500px;border:1px solid rgb(180,180,180)" id="echarts">
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import ApiClient from '@/api/ApiClient'
  export default {
    mounted: function () {
      // 基于准备好的dom，初  始化echarts实例
      let myChart = echarts.init(document.getElementById('echarts'))
      // 绘制图表，this.echarts1_option是数据
      ApiClient.get('/desktop/profile/asset.do').then(data => {
        this.asset = data;
        myChart.setOption({
          color:['rgb(220,20,60)', 'rgb(65,105,225)', 'rgb(34,139,34)', 'rgb(255,215,0)', 'rgb(255,152,63)','rgb(186,85,211)'],
          title: {
            text: '资金情况',
            left: 'center',
            top: 17,
            textStyle: {
              color: '#ccc',
              fontStyle: 'italic'//标题字体
            }
          },
          //弹窗，响应鼠标指向，显示具体细节
          tooltip: {
            trigger: 'item',//以具体项目触发弹窗
            /*
            内容格式器，一共有abcd四个代号，例如在饼图中，{a}指系列，即流量来源，{b}指数据项目，如搜索引擎，{c}指数值，如
            value，{d}百分比。{x}本身代表了相应字符，可以和其他字符拼凑，在弹窗中显示
            */
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          //图例，选择要显示的项目
          legend: {
            orient: 'vertical',
            left: 'top',
            top: '50',
            textStyle: {
              color: 'black'
            },
            data: ['总资产','可用余额','冻结金额','总保理金额','保理中', '近一周应还金额',]  //注意要和数据的name相对应
          },
          //工具箱
          toolbox: {
            show: true,//显示工具箱
            feature: {
              dataView: {show: true}, //以文字形式显示数据
              restore: {show: true},   //还原
              saveAsImage: {show: true},  //保存图片
            },
            right:30
          },
          //视觉映射组件，将数据映射到视觉元素上
          visualMap: {
            show: false,
            min: 10,
            max: 650,
            dimension: 0, //选取数据的维度，如人数据：[身高，体重]，则1代表将体重进行映射，默认值为数组的最后一位
            seriesIndex: 5, //选取数据集合中的哪个数组，如{一班}，{二班}，默认选取data中的所有数据集
            inRange: {
              //选定了要映射的对象，用inRange详细写要渲染的具体细节，[x，y]中x指最小值对应的量（亮度，饱和度等），y指最大值对应的量，其余的按各自value线性渲染
              colorLightness: [0, 1],
              colorSaturation: [0, 1]
            }
          },
            //数据
            series: [
              {
                name: '保理来源',
                type: 'pie',
                radius: '60%',
                center: ['50%', '55%'],
                roseType:'angle',
                data: [
                  {value: this.asset.totalMoney, name: '总资产'},
                  {value: this.asset.balance, name: '可用余额'},
                  {value: this.asset.freezeMoney, name: '冻结金额'},
                  {value: this.asset.totalLoanMoney, name: '总保理金额'},
                  {value: this.asset.loanMoney,name:'保理中'},
                  {value: this.asset.weekShouldRepayMoney, name: '近一周应还金额'},
                ].sort(function (a, b) {
                  return a.value - b.value;
                }),
                roseType: 'area',//角度和半径展现百分比，'area'只用半径展现
                label: { //饼图图形的文本标签
                  normal: {  //下同，normal指在普通情况下样式，而非高亮时样式
                    textStyle: {
                      color: 'black'
                    },
                  }
                },
                labelLine: {  //引导线样式
                  normal: {
                    lineStyle: {
                      color: '#412C5C'
                    },
                    smooth: 0.5, //0-1，越大越平滑弯曲
                    length: 10,  //从块到文字的第一段长
                    length2: 20  //拐弯到文字的段长
                  }
                },
                itemStyle: { //图例样式
                  normal: {
                    shadowBlur: 20,//阴影模糊程度 ?
                  },
                },
                animationType: 'scale', //初始动画效果，scale是缩放，expansion是展开
                animationEasing: 'elasticOut', //初始动画缓动效果,
              },
            ],

        })

      })
    },
    data(){
      return {
        asset: {
          totalMoney: '',
          totalLoanMoney: '',
          balance:'',
          weekShouldRepayMoney: '',
          freezeMoney: '',
          loanMoney:''
        },
      }
    },
  }
</script>
 
<style>
    #myChart{
     width: 100%
     }
</style>



// WEBPACK FOOTER //
// src/components/Echarts.vue